function tableAjaxCall(table, route, method, data, pollingroute, eventname, callback) {

    var id = table.table().node().id;
    var loading = $('.' + id +'.loading');

    if (pollingroute && eventname && window.EventSource) {
        loading.toggleClass(eventname);
        var source = new EventSource(pollingroute);
        source.addEventListener(eventname, function (event) {
            var data = JSON.parse(event.data);
            var perc = (data.partial / data.total) * 100;
            $('.' + eventname + ' #progress').text(Math.round(perc) + '%');
        });
    }

    if (!method)
       method = 'POST';

    var toastrOptions = { progressBar : false }

    loading.toggleClass('hide');

    $.ajax({
        type: method,
        url: route,
        data: data,
        dataType: 'json',
        success: function (data) {
            if(callback instanceof Function)
                callback(data);
            if(data.message)
                toastr.success(data.message, '', toastrOptions);
            toastrOptions.onHidden = null;
            table.draw(false);

            loading.toggleClass('hide');
            if (pollingroute && eventname && window.EventSource) {
                loading.toggleClass(eventname);
                source.close();
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            /*if(jqXHR.status == 401)
                window.location.href = '/login';*/

            var data = JSON.parse(jqXHR.responseText);
            if(data.message)
                toastr.error(data.message);
            loading.toggleClass('hide');
            if (pollingroute && eventname && window.EventSource) {
                loading.toggleClass(eventname);
                source.close();
            }
        }
    });
}

function ajaxCall(route, method, data, successCallback, errorCallback, dataTable, processData, contentType) {
    $.ajax({
        type: method,
        url: route,
        data: data,
        dataType: 'json',
        processData: processData ?? true,
        contentType: contentType ?? 'application/x-www-form-urlencoded; charset=UTF-8',
        beforeSend: function(request) {
            request.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
            request.setRequestHeader('Accept', 'application/json');
        },
        success: function (data) {
            if(data.message) {
                toastr.success(data.message, '', {closeButton : false})
            }

            if(successCallback instanceof Function) {
                successCallback(data);
            }

            if(dataTable) {
                dataTable.draw(false);
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.log('AJAX Error Details:');
            console.log('Status:', jqXHR.status);
            console.log('textStatus:', textStatus);
            console.log('errorThrown:', errorThrown);
            console.log('responseText:', jqXHR.responseText);

            // Se è un parsererror, potrebbe essere che la risposta è OK ma non è JSON valido
            if (textStatus === 'parsererror') {
                // Prova a vedere se c'è contenuto valido nella risposta
                console.log('Parse error - checking if response contains valid data');
                try {
                    // A volte c'è del contenuto extra prima/dopo il JSON
                    let responseText = jqXHR.responseText;
                    // Cerca di trovare un JSON valido nella risposta
                    let jsonMatch = responseText.match(/\{[\s\S]*\}/);
                    if (jsonMatch) {
                        let parsedData = JSON.parse(jsonMatch[0]);
                        console.log('Found valid JSON in response:', parsedData);
                        // Se abbiamo trovato dati validi, chiamiamo il success callback
                        if (parsedData && (parsedData.data || parsedData.appointment)) {
                            toastr.success(parsedData.message || 'Operation completed', '', {closeButton: false});
                            if (successCallback instanceof Function) {
                                successCallback(parsedData);
                            }
                            if (dataTable) {
                                dataTable.draw(false);
                            }
                            return;
                        }
                    }
                } catch (e) {
                    console.log('Could not extract JSON from response:', e);
                }
                toastr.error('Invalid response format from server', '', {closeButton: false});
                if (errorCallback instanceof Function) {
                    errorCallback(null, jqXHR, textStatus);
                }
                return;
            }

            let data = jqXHR.responseJSON;

            if (data && data.message) {
                toastr.error(data.message, '', {closeButton: false});
            } else if (data) {
                for (let err in data) {
                    let message = data[err];
                    toastr.error(message, '', {closeButton: false});
                }
            } else {
                toastr.error(textStatus || errorThrown || 'An error occurred', '', {closeButton: false});
            }

            if (errorCallback instanceof Function) {
                errorCallback(data, jqXHR, textStatus);
            }
        }
    });
}

const extractStringForAvatar = (avatarString) => {
    let dividedString = avatarString.trim().split(' ');
    let firstAndLastWord = dividedString.length > 1 ? [dividedString[0],dividedString[dividedString.length-1]] : [dividedString[0]];
    return firstAndLastWord.map(word => word[0]).join('');
}

const generateAvatarFromString = (avatarString, element = 'div', classes = '', extra = '') => {
    const content = extractStringForAvatar(avatarString);
    return `<${element} class="generated-avatar ${classes}" ${extra}>${content}</${element}>`;
}


